@use 'sass:map';
@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: inline-block;
  max-width: 100%;

  .fluid-button-group {
    display: flex;
    flex-wrap: wrap;
    font-weight: var(--font-weight);
    color: var(--text-color);
    line-height: 1;

    &.tile-buttons {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(10em, 1fr));
      grid-auto-rows: minmax(5em, 1fr);
      gap: 1em;
    }

    // ==== Option Button

    .button-group-option {
      display: flex;
      align-items: center;
      gap: 0.6em;
      position: relative;
      padding-top: var(--option-padding-top);
      padding-bottom: var(--option-padding-bottom);
      padding-left: var(--option-padding-left);
      padding-right: var(--option-padding-right);
      font-weight: var(--font-weight);
      color: var(--text-color);
      text-align: center;
      background-color: var(--option-background-color);
      border-style: solid;
      border-color: var(--option-border-color);
      border-top-width: var(--G-border-width);
      border-bottom-width: var(--G-border-width);
      border-left-width: 0;
      border-right-width: 0;
      cursor: pointer;
      outline: 0;

      @include transition(
        $properties: 'color, background-color, border-color, opacity',
        $duration: short
      );

      &:not(.tile-button) {

        // == First/Last Option Borders

        &:first-of-type {
          border-top-left-radius: var(--border-radius);
          border-bottom-left-radius: var(--border-radius);
          border-left-width: var(--G-border-width);
        }

        &:last-of-type {
          border-top-right-radius: var(--border-radius);
          border-bottom-right-radius: var(--border-radius);
          border-right-width: var(--G-border-width);
        }

        // == Option Dividers (Left/Right Border)

        @mixin btn-group-option-divider {
          width: var(--G-border-width);
          display: block;
          position: absolute;
          top: -1px;
          bottom: -1px;
          background-color: var(--option-border-color);
          content: '';

          @include transition(
            $properties: 'background-color',
            $duration: short
          );
        }

        &:not(:first-of-type) {
          &::before {
            @include btn-group-option-divider;
            left: -1px;
          }
        }

        &:not(:last-of-type) {
          &::after {
            @include btn-group-option-divider;
            right: 0;
          }
        }

        &:hover,
        &:focus-visible,
        &.option-selected {
          & + .button-group-option:not(.option-selected) {
            &::before {
              background-color: transparent;
            }
          }
        }
      }

      // == Tile Button

      &.tile-button {
        height: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: var(--tile-button-padding-top);
        padding-bottom: var(--tile-button-padding-bottom);
        border-width: var(--tile-button-border-width);
        border-radius: var(--G-border-radius);
        box-shadow: var(--tile-button-box-shadow);
      }

      // == Icon Color States

      &:hover:not(.option-disabled),
      &:focus-visible:not(.option-disabled),
      &.option-selected {
        .severity-icon,
        .color-override {
          // !important overrides inline "style" attr
          color: var(--text-color) !important;
        }
      }

      // == Disabled State

      &.option-disabled {
        cursor: not-allowed;

        &.option-selected {
          opacity: 0.75;
        }
      }
    }

    // ==== Option Radio Button (Hidden)

    .option-input {
      display: none;
    }

    // ==== Option Icon

    .option-icon {
      pointer-events: none;

      // == Deprecated "icon" Property Colors

      &.icon-success {
        color: var(--G-color-success-fill);
      }

      &.icon-info {
        color: var(--G-color-info-fill);
      }

      &.icon-warning {
        color: var(--G-color-warning-fill);
      }

      &.icon-error {
        color: var(--G-color-error-fill);
      }

      // == Transitions

      &.severity-icon,
      &.color-override {
        // Must be applied here to prevent "double transition" effect
        @include transition(
          $properties: 'color',
          $duration: short
        );
      }
    }
  }
}

// == Tile Buttons

:host(.fluid-button-group--tile-buttons) {
  display: block;
}
